
import React, { useEffect, useState } from 'react'
import { Box, Divider, Typography, Button, Paper, 
    IconButton, InputBase } from '@mui/material'
import { grey, red } from '@mui/material/colors'
import { getProfileExist } from '../../../services/user-services'
import { convertToFaToEn } from '../../../services/utils'
// import Link from 'next/link'
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback'
import Notification from "../../notification/notification"
import CircularProgress from '@mui/material/CircularProgress';
import { debounce } from 'lodash';

// import dynamic from 'next/dynamic';
// const WaitingView = dynamic(
//     () => import("../../Maps/detail/common/Progress/back-drop"),
//     { ssr: false }
// )
// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: theme.palette.text.secondary,
// }))


export default function LoginPhone({ userPhone, onBack}) {
    // const { onNext, onBack, famili, user_name } = props
    // const timerNow = useTimer(12)
    const [mobileNumber, setMobileNumber ] = useState('')

    const [loading, setLoading ] = useState(false)

    const [notiShow, setNotiShow] = useState(false)
    const [notiTitle, setNotiTitle] = useState('')
    const [notiType, setNotiType] = useState("success")
    const inputRef = React.useRef();
  
    useEffect(() => {
      inputRef.current?.focus();
    }, [inputRef]);
  
    const setTextInputRef = (element) => {
      inputRef.current = element;
    };
    
    // const handlerTimer = (value:number) => {
    //     setTimerRemain(value)
    // }
    useEffect(() => {
        setMobileNumber(userPhone)
    }, [userPhone])
    
    const handlerNextSMSCode = async (phone) => {
        inputRef.current?.focus();
        if(phone && phone.length >= 10)
        {
            setLoading(true)
            await getProfileExist({phone: phone, login: "Ok"})
            .then(res => {
                // console.log(res?.message);
                if(!res.Error){
                    let dataRes = {
                        mobile_number: phone,
                        login: false,
                        num_check: res?.num_check ? res?.num_check : 0,
                        type_sms: 1
                    }
                    if(res?.message === "Ok accont"){
                        dataRes['login'] = true
                        dataRes['type_sms'] = 0
                    }
                    if(res?.message_err)
                    {
                        setNotiShow(true)
                        setNotiTitle(res?.message_err)
                        setNotiType("success")
                    }
                    
                    onBack(dataRes)
                }else if(res?.message){
                    setNotiShow(true)
                    setNotiTitle(res?.message)
                    setNotiType("error")
                }
                
                setLoading(false)
            })
            .catch(err =>{
                setLoading(false)
            })
        }
    }

    
    const handlerBackNoti = () => {
        setNotiShow(false)
    }
    // const sleep_ = (ms: number) => new Promise((r) => setTimeout(r, ms));
    // function sleep(ms:number) {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }
    // const handleBack = () => {
    //     onBack()
    // };

    const handleChange = (e) => {
        const re = /^[0-9۰-۹]+$/;
        const inputValue = convertToFaToEn(String(e.target.value));
        if (re.test(inputValue) && inputValue.length <= 11 && !inputValue.startsWith('0')) {
            setMobileNumber(inputValue)
            debouncedHandlerNextSMSCode(inputValue);
        } else {
            setMobileNumber("")
            setNotiShow(true)
            setNotiTitle('لطفا با اعداد انگلیسی بنویسید')
            setNotiType("error")
        }
    };
    
    const debouncedHandlerNextSMSCode = debounce((inputValue) => {
        
        if (inputValue.length >= 10) {
            handlerNextSMSCode(convertToFaToEn(inputValue));
        }
    }, 300);
    

  return (
    
    <Box 
        sx={{  
            bgcolor: 'background.paper', 
        }}
        >
        {loading &&
            <CircularProgress />
        }
        <div dir='rtl' className='text-right'>
            <Paper 
                elevation={3}
                >
                    
                <Box component="section" sx={{ p: 2 }}>
                    <div className='-mt-5 pb-5'>
                        <Typography 
                            fontFamily='vaziri' 
                            component="div"
                            variant="h6"
                            color={grey[800]}
                            >
                            شمارهٔ موبایل خود را وارد کنید
                        </Typography>
                    </div>
                    <div className='pb-3'>
                        <Typography 
                            fontFamily='vaziri_light' 
                            component="div"
                            variant="body2"
                            color={grey[600]}
                            >
                            قبل از ثبت آگهی، لطفاً وارد حساب خود شوید.
                        </Typography>
                    </div>
                    <div className='pb-3'>
                        <Typography 
                            fontFamily='vaziri_light' 
                            component="div"
                            variant="body2"
                            color={grey[600]}
                            >
                            کد تأیید به این شماره پیامک می‌شود.
                        </Typography>
                    </div>
                </Box>
                <div className='w-full text-center items-center px-5 mb-5' dir='ltr'>
                    <Paper
                        sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
                        >
                        <IconButton sx={{ p: '10px' }} aria-label="menu">
                            <Typography 
                                fontFamily='b_mitra' 
                                component="span"
                                variant="h5"
                                color={grey[900]}
                                >
                                {"+98"}
                            </Typography>
                        </IconButton>
                        <InputBase
                            sx={{ ml: 1, flex: 1, fontSize: 16 }}
                            placeholder={'9121234567'}
                            inputProps={{
                                'aria-label': 'search',
                                fontSize: 22,
                                style: {
                                fontSize: 24,
                                fontFamily: 'b_mitra',
                                }
                            }}
                            inputRef={setTextInputRef}
                            value={mobileNumber}
                            onChange={handleChange}
                            />

                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions">
                            <PhoneCallbackIcon />
                        </IconButton>
                    </Paper>
                </div>
                <div className='w-full text-right items-right px-5' dir='rtl'>
                    <a href={'/conditions'}>
                        <Typography 
                            fontFamily='vaziri_light' 
                            component="span"
                            variant="body2"
                            color={red[600]}
                            >
                            {"شرایط استفاده از خدمات "}
                        </Typography>
                    </a>
                    <Typography 
                        fontFamily='vaziri_light' 
                        component="span"
                        variant="body2"
                        color={grey[600]}
                        >
                        {"و "}
                    </Typography>
                    <a href={'/privacy'}>
                        <Typography 
                            fontFamily='vaziri_light' 
                            component="span"
                            variant="body2"
                            color={red[600]}
                            >
                            {"حریم خصوصی "}
                        </Typography>
                    </a>
                    <Typography 
                        fontFamily='vaziri_light' 
                        component="span"
                        variant="body2"
                        color={grey[600]}
                        >
                        چاربازار را می‌پذیرم.
                    </Typography>
                </div>

                <div className="text-left mt-5">
                    <Button variant="contained" 
                        color="primary" 
                        sx={{m: 2, px: 5}}
                        disabled={!mobileNumber}
                        onClick={() => handlerNextSMSCode(mobileNumber)}
                        >
                        <Typography 
                            fontFamily="Segoe UI"
                            component="span"
                            variant="h6"
                            color={"secondry"}
                            >
                            تایید
                        </Typography>
                    </Button>
                </div>
            </Paper>
            <div>
                <Notification
                    viewNoti={notiShow}
                    title={notiTitle} 
                    severity={notiType}
                    onBack={handlerBackNoti}
                    />
            </div>
        </div>
    </Box>
    
    );
}
